export const YOUTUBE = {
  adsPlaylistId: 'PLedsirJcpA1LDed1yl2ogLO7t57INaq_e',
  channelId: 'UCZ85UhK5tgU2OzXWin81GWA',
  howToVideoId: 'UQZqPWLrU-c'
};
